import {
  OvieHealthSettingsAction,
  isOvieHealthSettingsRequest,
} from './settings-action';
import type {
  IOvieHealthSettingsRequest,
  IOvieHealthSettingsResponse,
} from './settings-request';

export type IOvieHealthAgentNumberRequest =
  IOvieHealthSettingsRequest<OvieHealthSettingsAction.GetAgentNumber>;

export type IOvieHealthAgentNumberResponse =
  IOvieHealthSettingsResponse<OvieHealthSettingsAction.GetAgentNumber>;

export function isOvieHealthAgentNumberRequest(
  data: unknown
): data is IOvieHealthAgentNumberRequest {
  return (
    isOvieHealthSettingsRequest(data) &&
    data.action === OvieHealthSettingsAction.GetAgentNumber
  );
}
